import createReactComponent from '../createReactComponent';
export default createReactComponent('code', 'IconCode', [
  ['path', { d: 'M7 8l-4 4l4 4', key: 'svg-0' }],
  ['path', { d: 'M17 8l4 4l-4 4', key: 'svg-1' }],
  ['path', { d: 'M14 4l-4 16', key: 'svg-2' }],
]);
